// extracted by mini-css-extract-plugin
export default {"menu":"menu_SIkG","menuWithAnnouncementBar":"menuWithAnnouncementBar_GW3s"};